(function () {
  "use strict";

  class ProductCardModelComponent extends HTMLElement {
    constructor() {
      super();
      this._isConnected = false;
      this._needsRender = false;
      this._renderRAF = null;
      this._lastHTML = null;
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      if (this._isConnected) {
          this._scheduleRender();
      } else {
        this._needsRender = true;
      }
    }

    connectedCallback() {
      this._isConnected = true;
      if (this._product && this._needsRender) {
        this._scheduleRender();
        this._needsRender = false;
      } else if (this._product && this._lastHTML == null) {
        this._scheduleRender();
      }
    }

    disconnectedCallback() {
      this._isConnected = false;
      if (this._renderRAF) {
        cancelAnimationFrame(this._renderRAF);
        this._renderRAF = null;
      }
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (name === "product" && newVal && newVal !== oldVal) {
        try {
          const parsed = JSON.parse(newVal);
          this.product = parsed;
        } catch (e) {
          // ignore invalid JSON
        }
      }
    }

    _scheduleRender() {
      if (this._renderRAF) cancelAnimationFrame(this._renderRAF);
      this._renderRAF = requestAnimationFrame(() => {
        this._renderRAF = null;
        this._doRender();
      });
    }

    _doRender() {
      if (!this._product) {
        this.innerHTML = "";
        this._lastHTML = null;
        return;
      }

      const safeText = (val) => (val == null ? "" : String(val));

      // Variants and selection
      const variants = Array.isArray(this._product?.variants)
        ? this._product.variants
        : [];
      const selectedVariantNumericId = safeText(this._product?.variantId || "");
      const getNumericId = (gidOrId) =>
        typeof gidOrId === "string" && gidOrId.includes("/")
          ? gidOrId.split("/").pop()
          : String(gidOrId || "");
      const selectedVariant =
        variants.find((v) => getNumericId(v.id) === selectedVariantNumericId) ||
        variants[0] ||
        null;

      // SKU for display (use selected or first variant)
      const sku = safeText(selectedVariant?.sku || variants[0]?.sku || "");

      // Build only the SKU section
      const html = `
              ${
                sku
                  ? `<p><span class="uppercase">Model: </span><span>${safeText(
                      sku.split(".")[0]
                    )}</span><span data-swatch-variant-sku class="hidden">${safeText(
                      sku
                    )}</span></p>`
                  : ""
              }
      `;
      
      if (html !== this._lastHTML) {
        this.innerHTML = html;
        this._lastHTML = html;
      }
    }
  }

  customElements.define("rcc-product-card-model", ProductCardModelComponent);
})();
